import { render, staticRenderFns } from "./CustomizeBase.vue?vue&type=template&id=754b419a&scoped=true&"
import script from "./CustomizeBase.vue?vue&type=script&lang=ts&"
export * from "./CustomizeBase.vue?vue&type=script&lang=ts&"
import style0 from "./CustomizeBase.vue?vue&type=style&index=0&id=754b419a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b419a",
  null
  
)

export default component.exports